
import sharedStyles from "./shared.module.css";
import { ProjectType } from "../Utils/ProjectType.ts";
import InfoPopup from "../Utils/InfoPopup.jsx";


export default function ProjectHeader ({title, subTitle, projectType, subTitleInfo, subTitleInfoLeft=false}) {


    return (
        <div className={sharedStyles.projectHeader}>
            <div>
                <h3>{title}</h3>
                { subTitleInfo ? 
                    <InfoPopup info={subTitleInfo} alignLeft={subTitleInfoLeft}>
                        <h4 className={sharedStyles.info} >{subTitle}</h4>
                    </InfoPopup>
                    :
                    <h4 className={sharedStyles.info} >{subTitle}</h4>
                }
            </div>
            <div className={sharedStyles.projectHeaderImage}>
                { projectType === ProjectType.Code && 
                    <InfoPopup alighRight={true} info={"My keyboard inspires me to write code!"} >
                        <img src="/images/my-keyboard-saturated.png" alt="My keyboard" className={sharedStyles.keyboard} />
                    </InfoPopup>
                }


                    
                { projectType === ProjectType.Music && 
                    <InfoPopup alighRight={true} info={"I recently bought this Cordoba classical guitar, and I love it! It sounds great playing Jazz, Bossa Nova, Folk, etc. Looks great, minimal fuss, just pick it up and play! Awesome!"} >
                        <img src="/images/my-guitar.png" alt="My Guitar" className={sharedStyles.guitar} />
                    </InfoPopup>
                }
            </div>
        </div>
    )
}